import React from 'react';
import { Link } from 'react-router-dom';
import defaultBanner from '../../assets/img/delivery1.webp';

const InnerBanner = ({
    title,
    current,
    backgroundImage = defaultBanner,
    parentLabel = 'Home',
    parentTo = '/',
}) => (
    <section className="inner-banner-wrap">
        <div
            className="inner-baner-container"
            style={{ backgroundImage: `url(${backgroundImage})` }}
        >
            <div className="container">
                <div className="inner-banner-content">
                    <h1 className="inner-title">{title}</h1>
                    <ul>
                        <li>
                            <Link to={parentTo}>
                                <i aria-hidden="true" className="fa fa-home" /> {parentLabel}
                            </Link>
                        </li>
                        <li>/ {current || title}</li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
);

export default InnerBanner;
